import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledBlock,
  StyledDescription,
  StyledTitle,
  StyledWhiteText,
} from './FormStyledComponents';

interface IFormHeader {
  title: string | React.ReactNode;
  description?: string;
  highlightedValue?: string;
}

const FormHeader: React.FC<IFormHeader> = ({ title, description, highlightedValue }) => {
  let desciptionValue: string | React.ReactNode = description;
  if (highlightedValue) {
    const index = description.indexOf(highlightedValue);
    desciptionValue = [
      description.slice(0, index),
      <StyledWhiteText key="highlighted">{highlightedValue}</StyledWhiteText>,
      description.slice(index + highlightedValue.length),
    ];
  }
  return (
    <div>
      <StyledBlock>
        <StyledTitle>{title}</StyledTitle>
      </StyledBlock>
      <StyledBlock>
        <StyledDescription>{desciptionValue}</StyledDescription>
      </StyledBlock>
    </div>
  );
};

FormHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.string,
};

export default FormHeader;
